import React, { Component } from "react";
import _ from "lodash";
import Button from "../base-components/button"
import { sendAPIRequest } from "shared/utils/requests";

class Transcribing extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  async submitTranscribing() {
    const {
      updateOnboardingStep,
    } = this.props;

    const response = await sendAPIRequest(`/onboarding/submit_transcribing`, "POST", { });
    if (response.data.status == 'success') {
      updateOnboardingStep(response.data.onboardingStep);
    } else {
      throw new Error("invalid status for transcribing submission: " + response.data.status)
    }
  }

  render() {
    const {
      currentContractor,
    } = this.props;

    return (
      <div className="onboarding-transcribing-container">
        <div className="onboarding-title">
          Are You Ready to Start Transcribing?
        </div>
        <div className="onboarding-biglabel onboarding-transcribing-body">
          The best way to be a successful transcriber is to fully understand the FAQs and frequently make use of our slack support channel and community. Whatever is outlined in the FAQ supersedes any portion of the Training Videos that will seem to be different to you. We always follow the FAQ.
          <br /> <br />
          <a href="https://www.google.com/url?q=https://docs.google.com/document/d/19M4nOtK_dFKzZHSroA5KQep1NenXMnh2NpTc4B8byu4/edit&sa=D&ust=1568245759808000&usg=AFQjCNHv3NFgh4505KiEni8fWs7MzBprGw" target="_blank"  rel="noopener noreferrer" className="onboarding-transcribing-links">Review the FAQ</a>
          <br /> <br />
          If you choose to begin transcribing, you will be transcribing a real call that if you pass you will get paid for but if you don’t pass it will count as a failing transcript and you will not get paid.
        </div>
        <div className="onboarding-transcribing-submission">
          <Button className="onboarding-submission-button" onClick={() => this.submitTranscribing()} text="Start Transcribing" />
        </div>
      </div>
    );  }

}

export default Transcribing;
